import './index-scoped.css'; // Use scoped CSS to prevent style leakage to host

// Dynamic import for Module Federation
import('./bootstrap');
